import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Breadcrumb from '../../../../shared/breadcrumb/Breadcrumb';
import Items from './Items';
import { Tabs } from '../../../../components';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedTab: 0,
    };
  }

  changeSelectedTab = (/* { index } */) => {
    // this.setState({ selectedTab: index });
  };

  render() {
    const { match } = this.props;
    return (
      <div>
        <Breadcrumb crumb="Pranchetas" description="Gerencie os pedidos de pranchetas." />

        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Todos', path: `${match.url}/todos` },
              { title: 'Pendente', path: `${match.url}/pendentes` },
              { title: 'Preparação', path: `${match.url}/preparacao` },
              { title: 'Pronto p/ Entrega', path: `${match.url}/prontos` },
              { title: 'Entregue', path: `${match.url}/entregue` },
              { title: 'Devolvido', path: `${match.url}/devolvido` },
              { title: 'Cancelado', path: `${match.url}/cancelado` },
            ]}
          />
          <Route
            path={`${match.url}/todos`}
            component={() => (
              <Items
                {...this.props}
                defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido="
              />
            )}
          />
          <Route
            path={`${match.url}/pendentes`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=true&preparacao=&prontoEntrega=&entregue=&devolvido="
              />
            )}
          />
          <Route
            path={`${match.url}/preparacao`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=&preparacao=true&prontoEntrega=true&entregue=&devolvido="
              />
            )}
          />
          <Route
            path={`${match.url}/prontos`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=&preparacao=&prontoEntrega=true&entregue=&devolvido="
              />
            )}
          />
          <Route
            path={`${match.url}/entregue`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=true&devolvido="
              />
            )}
          />
          <Route
            path={`${match.url}/devolvido`}
            component={() => (
              <Items
                {...this.props}
                defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido=true"
              />
            )}
          />
          <Route
            path={`${match.url}/cancelado`}
            component={() => (
              <Items
                {...this.props}
                defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&devolvido=&cancelado=true"
              />
            )}
          />
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Clipboards/List.js